import { defaultLocale } from '@adsk/alloy-react-locale';

import { LOCALE_TO_FIRST_DAY_OF_WEEK } from './consts';
import { LocaleWithWeekInfo } from './types';

// 7 and 0 are equivalent for Sunday as first day of week, the Intl api uses 7, but we
// prefer to always use 0
const clamp = (num = 0) => (num >= 7 ? 0 : num);

// Intl.Locale.WeekInfo has partial support in browsers, the Locale polyfill from @formatjs
// doesn't polyfill the property we need.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
//   /Locale/weekInfo#browser_compatibility
const getFirstDayOfWeek = (locale?: string, firstDayOfWeekProp?: number) => {
  if (typeof firstDayOfWeekProp === 'number') return clamp(firstDayOfWeekProp);
  try {
    const isFunction = typeof Intl.Locale === 'function';

    const { weekInfo }: LocaleWithWeekInfo = isFunction
      ? // Required for https://git.autodesk.com/BIM360/alloy-react/pull/1901
        // @ts-expect-error Intl.Locale is a function in ES2015 target but TS doesn't agree
        Intl.Locale(locale ?? defaultLocale)
      : new Intl.Locale(locale ?? defaultLocale);

    return clamp(
      weekInfo?.firstDay ??
        LOCALE_TO_FIRST_DAY_OF_WEEK[locale ?? defaultLocale],
    );
  } catch {
    return clamp(LOCALE_TO_FIRST_DAY_OF_WEEK[locale ?? defaultLocale]);
  }
};

export default getFirstDayOfWeek;
